// src/pages/NotFound.js
import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import "./NotFound.css";
import NotFoundIcon from "./../../assets/error.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const NotFound = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("pageTitle"),
      description: t("pageDescription"),
      keywords: t("pageKeywords"),
      favicon: "/faviconnew.png",
      ogUrl: "https://mukemel.com/404",
    });
  }, [setSeo, t]);

  const navigate = useNavigate();
  useEffect(() => {
    navigate("/404", { replace: true });
  }, [navigate]);
  return (
    <>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-8 col-sm-10 col-12 text-center p-5 border-bottom">
            <img src={NotFoundIcon} className="w-50" alt="404Icon" />
            <h5 className="fw-normal text-uppercase">{t("headerText")}!</h5>
            <p className="fw-lighter">{t("bodyText")}</p>
          </div>
          <div className="col-lg-7 col-md-8 col-sm-10 col-12 mb-5">
            <p className="fw-light text-center py-5 pb-3">
              {t("helpQuestion")}
            </p>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <a
                  href="mailto:customer.support@mukemel.com"
                  className="text-decoration-none btn bgcolorfooterbottom w-100 p-2 fw-14 mb-3"
                >
                  <i className="fa-regular fa-envelope-open mx-1"></i>{" "}
                  {t("emailButton")}
                </a>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <a
                  href="tel:+905365049119​​"
                  className="text-decoration-none btn bgcolorfooterbottom w-100 p-2 fw-14 mb-3"
                >
                  <i className="fa-solid fa-mobile-screen mx-1"></i>
                  {t("callButton")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
